<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M1.66675 4.5C1.66675 3.39543 2.56218 2.5 3.66675 2.5H15.6668C16.7713 2.5 17.6667 3.39543 17.6667 4.5V5.5H1.66675V4.5Z"
      :fill="color"
    />
    <path
      d="M1.66675 6.5H17.6667V15.5C17.6667 16.6046 16.7713 17.5 15.6667 17.5H3.66675C2.56218 17.5 1.66675 16.6046 1.66675 15.5V6.5Z"
      :fill="color"
    />
  </svg>
</template>
